const dates: Mapping[] = [
  {value: 1, label: '1日'},
  {value: 2, label: '2日'},
  {value: 3, label: '3日'},
];
export default dates;
